// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ffff: #ffffff;
  --0000: #000000;
  --0001: #000000bb;
  --0d6e: #0d6efd;
  --0dca: #0dcaf0;
  --8754: #198754;
  --ad2a: #46ad2a;
  --f4e2: #e6f4e2;
  --ffc1: #ffc107;
  --e3e3: #e3e3e3;
  --2749: #0e2749;
  --dee3: #dcdee3;
  --edf0: #eaedf0;
  --56ff: #6c56ff;
  --7e91: #777e91;
  --f9fb: #f8f9fb;
  --4639: #d94639;
  --dc35: #dc3545;
  --e2e2: #f4e2e2;
  --2a2a: #ad2a2a;
  --faff: #fafaff;
  --eeff: #f0eeff;
  --b5c0: #b1b5c0;
  --bbff: #c4bbff;
  --1129: #0f1129;
  --4d6c: #4b4d6c;
  --2b4e: #282b4e;
  --c9c9: #c9c9c9;
  --102a: #0e102a;
  --2ae5: #070a3149;
  --041e: #02041e;
}

/* Light mode styles */
.color-tr {
  color: transparent !important;
}

.bg-tr {
  background-color: transparent !important;
}

.b-tr {
  border: transparent 1px solid !important;
}

.bs-tr {
  border-left: transparent 1px solid !important;
}

.be-tr {
  border-right: transparent 1px solid !important;
}

.bt-tr {
  border-top: transparent 1px solid !important;
}

.bb-tr {
  border-bottom: transparent 1px solid !important;
}

.color-ffff {
  color: var(--ffff) !important;
}

.bg-ffff {
  background-color: var(--ffff) !important;
}

.b-ffff {
  border: var(--ffff) 1px solid !important;
}

.bs-ffff {
  border-left: var(--ffff) 1px solid !important;
}

.be-ffff {
  border-right: var(--ffff) 1px solid !important;
}

.bt-ffff {
  border-top: var(--ffff) 1px solid !important;
}

.bb-ffff {
  border-bottom: var(--ffff) 1px solid !important;
}

.color-041e {
  color: var(--041e) !important;
}

.bg-041e {
  background-color: var(--041e) !important;
}

.b-041e {
  border: var(--041e) 1px solid !important;
}

.bs-041e {
  border-left: var(--041e) 1px solid !important;
}

.be-041e {
  border-right: var(--041e) 1px solid !important;
}

.bt-041e {
  border-top: var(--041e) 1px solid !important;
}

.bb-041e {
  border-bottom: var(--041e) 1px solid !important;
}

.color-2ae5 {
  color: var(--2ae5) !important;
}

.bg-2ae5 {
  background-color: var(--2ae5) !important;
}

.b-2ae5 {
  border: var(--2ae5) 1px solid !important;
}

.bs-2ae5 {
  border-left: var(--2ae5) 1px solid !important;
}

.be-2ae5 {
  border-right: var(--2ae5) 1px solid !important;
}

.bt-2ae5 {
  border-top: var(--2ae5) 1px solid !important;
}

.bb-2ae5 {
  border-bottom: var(--2ae5) 1px solid !important;
}

.color-c9c9 {
  color: var(--c9c9) !important;
}

.bg-c9c9 {
  background-color: var(--c9c9) !important;
}

.b-c9c9 {
  border: var(--c9c9) 1px solid !important;
}

.bs-c9c9 {
  border-left: var(--c9c9) 1px solid !important;
}

.be-c9c9 {
  border-right: var(--c9c9) 1px solid !important;
}

.bt-c9c9 {
  border-top: var(--c9c9) 1px solid !important;
}

.bb-c9c9 {
  border-bottom: var(--c9c9) 1px solid !important;
}

.color-2b4e {
  color: var(--2b4e) !important;
}

.bg-2b4e {
  background-color: var(--2b4e) !important;
}

.b-2b4e {
  border: var(--2b4e) 1px solid !important;
}

.bs-2b4e {
  border-left: var(--2b4e) 1px solid !important;
}

.be-2b4e {
  border-right: var(--2b4e) 1px solid !important;
}

.bt-2b4e {
  border-top: var(--2b4e) 1px solid !important;
}

.bb-2b4e {
  border-bottom: var(--2b4e) 1px solid !important;
}

.color-0000 {
  color: var(--0000) !important;
}

.bg-0000 {
  background-color: var(--0000) !important;
}

.b-0000 {
  border: var(--0000) 1px solid !important;
}

.bs-0000 {
  border-left: var(--0000) 1px solid !important;
}

.be-0000 {
  border-right: var(--0000) 1px solid !important;
}

.bt-0000 {
  border-top: var(--0000) 1px solid !important;
}

.bb-0000 {
  border-bottom: var(--0000) 1px solid !important;
}

.color-0d6e {
  color: var(--0d6e) !important;
}

.bg-0d6e {
  background-color: var(--0d6e) !important;
}

.b-0d6e {
  border: var(--0d6e) 1px solid !important;
}

.bs-0d6e {
  border-left: var(--0d6e) 1px solid !important;
}

.be-0d6e {
  border-right: var(--0d6e) 1px solid !important;
}

.bt-0d6e {
  border-top: var(--0d6e) 1px solid !important;
}

.bb-0d6e {
  border-bottom: var(--0d6e) 1px solid !important;
}

.color-0dca {
  color: var(--0dca) !important;
}

.bg-0dca {
  background-color: var(--0dca) !important;
}

.b-0dca {
  border: var(--0dca) 1px solid !important;
}

.bs-0dca {
  border-left: var(--0dca) 1px solid !important;
}

.be-0dca {
  border-right: var(--0dca) 1px solid !important;
}

.bt-0dca {
  border-top: var(--0dca) 1px solid !important;
}

.bb-0dca {
  border-bottom: var(--0dca) 1px solid !important;
}

.color-8754 {
  color: var(--8754) !important;
}

.bg-8754 {
  background-color: var(--8754) !important;
}

.b-8754 {
  border: var(--8754) 1px solid !important;
}

.bs-8754 {
  border-left: var(--8754) 1px solid !important;
}

.be-8754 {
  border-right: var(--8754) 1px solid !important;
}

.bt-8754 {
  border-top: var(--8754) 1px solid !important;
}

.bb-8754 {
  border-bottom: var(--8754) 1px solid !important;
}

.color-dc35 {
  color: var(--dc35) !important;
}

.bg-dc35 {
  background-color: var(--dc35) !important;
}

.b-dc35 {
  border: var(--dc35) 1px solid !important;
}

.bs-dc35 {
  border-left: var(--dc35) 1px solid !important;
}

.be-dc35 {
  border-right: var(--dc35) 1px solid !important;
}

.bt-dc35 {
  border-top: var(--dc35) 1px solid !important;
}

.bb-dc35 {
  border-bottom: var(--dc35) 1px solid !important;
}

.color-ffc1 {
  color: var(--ffc1) !important;
}

.bg-ffc1 {
  background-color: var(--ffc1) !important;
}

.b-ffc1 {
  border: var(--ffc1) 1px solid !important;
}

.bs-ffc1 {
  border-left: var(--ffc1) 1px solid !important;
}

.be-ffc1 {
  border-right: var(--ffc1) 1px solid !important;
}

.bt-ffc1 {
  border-top: var(--ffc1) 1px solid !important;
}

.bb-ffc1 {
  border-bottom: var(--ffc1) 1px solid !important;
}

.color-e3e3 {
  color: var(--e3e3) !important;
}

.bg-e3e3 {
  background-color: var(--e3e3) !important;
}

.b-e3e3 {
  border: var(--e3e3) 1px solid !important;
}

.bs-e3e3 {
  border-left: var(--e3e3) 1px solid !important;
}

.be-e3e3 {
  border-right: var(--e3e3) 1px solid !important;
}

.bt-e3e3 {
  border-top: var(--e3e3) 1px solid !important;
}

.bb-e3e3 {
  border-bottom: var(--e3e3) 1px solid !important;
}

.color-2749 {
  color: var(--2749) !important;
}

.bg-2749 {
  background-color: var(--2749) !important;
}

.b-2749 {
  border: var(--2749) 1px solid !important;
}

.bs-2749 {
  border-left: var(--2749) 1px solid !important;
}

.be-2749 {
  border-right: var(--2749) 1px solid !important;
}

.bt-2749 {
  border-top: var(--2749) 1px solid !important;
}

.bb-2749 {
  border-bottom: var(--2749) 1px solid !important;
}

.color-dee3 {
  color: var(--dee3) !important;
}

.bg-dee3 {
  background-color: var(--dee3) !important;
}

.b-dee3 {
  border: var(--dee3) 1px solid !important;
}

.bs-dee3 {
  border-left: var(--dee3) 1px solid !important;
}

.be-dee3 {
  border-right: var(--dee3) 1px solid !important;
}

.bt-dee3 {
  border-top: var(--dee3) 1px solid !important;
}

.bb-dee3 {
  border-bottom: var(--dee3) 1px solid !important;
}

.color-edf0 {
  color: var(--edf0) !important;
}

.bg-edf0 {
  background-color: var(--edf0) !important;
}

.b-edf0 {
  border: var(--edf0) 1px solid !important;
}

.bs-edf0 {
  border-left: var(--edf0) 1px solid !important;
}

.be-edf0 {
  border-right: var(--edf0) 1px solid !important;
}

.bt-edf0 {
  border-top: var(--edf0) 1px solid !important;
}

.bb-edf0 {
  border-bottom: var(--edf0) 1px solid !important;
}

.color-56ff {
  color: var(--56ff) !important;
}

.bg-56ff {
  background-color: var(--56ff) !important;
}

.b-56ff {
  border: var(--56ff) 1px solid !important;
}

.bs-56ff {
  border-left: var(--56ff) 1px solid !important;
}

.be-56ff {
  border-right: var(--56ff) 1px solid !important;
}

.bt-56ff {
  border-top: var(--56ff) 1px solid !important;
}

.bb-56ff {
  border-bottom: var(--56ff) 1px solid !important;
}

.color-7e91 {
  color: var(--7e91) !important;
}

.bg-7e91 {
  background-color: var(--7e91) !important;
}

.b-7e91 {
  border: var(--7e91) 1px solid !important;
}

.bs-7e91 {
  border-left: var(--7e91) 1px solid !important;
}

.be-7e91 {
  border-right: var(--7e91) 1px solid !important;
}

.bt-7e91 {
  border-top: var(--7e91) 1px solid !important;
}

.bb-7e91 {
  border-bottom: var(--7e91) 1px solid !important;
}

.color-f9fb {
  color: var(--f9fb) !important;
}

.bg-f9fb {
  background-color: var(--f9fb) !important;
}

.b-f9fb {
  border: var(--f9fb) 1px solid !important;
}

.bs-f9fb {
  border-left: var(--f9fb) 1px solid !important;
}

.be-f9fb {
  border-right: var(--f9fb) 1px solid !important;
}

.bt-f9fb {
  border-top: var(--f9fb) 1px solid !important;
}

.bb-f9fb {
  border-bottom: var(--f9fb) 1px solid !important;
}

.color-4639 {
  color: var(--4639) !important;
}

.bg-4639 {
  background-color: var(--4639) !important;
}

.b-4639 {
  border: var(--4639) 1px solid !important;
}

.bs-4639 {
  border-left: var(--4639) 1px solid !important;
}

.be-4639 {
  border-right: var(--4639) 1px solid !important;
}

.bt-4639 {
  border-top: var(--4639) 1px solid !important;
}

.bb-4639 {
  border-bottom: var(--4639) 1px solid !important;
}

.color-faff {
  color: var(--faff) !important;
}

.bg-faff {
  background-color: var(--faff) !important;
}

.b-faff {
  border: var(--faff) 1px solid !important;
}

.bs-faff {
  border-left: var(--faff) 1px solid !important;
}

.be-faff {
  border-right: var(--faff) 1px solid !important;
}

.bt-faff {
  border-top: var(--faff) 1px solid !important;
}

.bb-faff {
  border-bottom: var(--faff) 1px solid !important;
}

.color-eeff {
  color: var(--eeff) !important;
}

.bg-eeff {
  background-color: var(--eeff) !important;
}

.b-eeff {
  border: var(--eeff) 1px solid !important;
}

.bs-eeff {
  border-left: var(--eeff) 1px solid !important;
}

.be-eeff {
  border-right: var(--eeff) 1px solid !important;
}

.bt-eeff {
  border-top: var(--eeff) 1px solid !important;
}

.bb-eeff {
  border-bottom: var(--eeff) 1px solid !important;
}

.color-b5c0 {
  color: var(--b5c0) !important;
}

.bg-b5c0 {
  background-color: var(--b5c0) !important;
}

.b-b5c0 {
  border: var(--b5c0) 1px solid !important;
}

.bs-b5c0 {
  border-left: var(--b5c0) 1px solid !important;
}

.be-b5c0 {
  border-right: var(--b5c0) 1px solid !important;
}

.bt-b5c0 {
  border-top: var(--b5c0) 1px solid !important;
}

.bb-b5c0 {
  border-bottom: var(--b5c0) 1px solid !important;
}

.color-bbff {
  color: var(--bbff) !important;
}

.bg-bbff {
  background-color: var(--bbff) !important;
}

.b-bbff {
  border: var(--bbff) 1px solid !important;
}

.bs-bbff {
  border-left: var(--bbff) 1px solid !important;
}

.be-bbff {
  border-right: var(--bbff) 1px solid !important;
}

.bt-bbff {
  border-top: var(--bbff) 1px solid !important;
}

.bb-bbff {
  border-bottom: var(--bbff) 1px solid !important;
}

.color-ad2a {
  color: var(--ad2a) !important;
}

.bg-ad2a {
  background-color: var(--ad2a) !important;
}

.b-ad2a {
  border: var(--ad2a) 1px solid !important;
}

.bs-ad2a {
  border-left: var(--ad2a) 1px solid !important;
}

.be-ad2a {
  border-right: var(--ad2a) 1px solid !important;
}

.bt-ad2a {
  border-top: var(--ad2a) 1px solid !important;
}

.bb-ad2a {
  border-bottom: var(--ad2a) 1px solid !important;
}

.color-f4e2 {
  color: var(--f4e2) !important;
}

.bg-f4e2 {
  background-color: var(--f4e2) !important;
}

.b-f4e2 {
  border: var(--f4e2) 1px solid !important;
}

.bs-f4e2 {
  border-left: var(--f4e2) 1px solid !important;
}

.be-f4e2 {
  border-right: var(--f4e2) 1px solid !important;
}

.bt-f4e2 {
  border-top: var(--f4e2) 1px solid !important;
}

.bb-f4e2 {
  border-bottom: var(--f4e2) 1px solid !important;
}

.color-e2e2 {
  color: var(--e2e2) !important;
}

.bg-e2e2 {
  background-color: var(--e2e2) !important;
}

.b-e2e2 {
  border: var(--e2e2) 1px solid !important;
}

.bs-e2e2 {
  border-left: var(--e2e2) 1px solid !important;
}

.be-e2e2 {
  border-right: var(--e2e2) 1px solid !important;
}

.bt-e2e2 {
  border-top: var(--e2e2) 1px solid !important;
}

.bb-e2e2 {
  border-bottom: var(--e2e2) 1px solid !important;
}

.color-2a2a {
  color: var(--2a2a) !important;
}

.bg-2a2a {
  background-color: var(--2a2a) !important;
}

.b-2a2a {
  border: var(--2a2a) 1px solid !important;
}

.bs-2a2a {
  border-left: var(--2a2a) 1px solid !important;
}

.be-2a2a {
  border-right: var(--2a2a) 1px solid !important;
}

.bt-2a2a {
  border-top: var(--2a2a) 1px solid !important;
}

.bb-2a2a {
  border-bottom: var(--2a2a) 1px solid !important;
}

.color-0001 {
  color: var(--0001) !important;
}

.bg-0001 {
  background-color: var(--0001) !important;
}

.b-0001 {
  border: var(--0001) 1px solid !important;
}

.bs-0001 {
  border-left: var(--0001) 1px solid !important;
}

.be-0001 {
  border-right: var(--0001) 1px solid !important;
}

.bt-0001 {
  border-top: var(--0001) 1px solid !important;
}

.bb-0001 {
  border-bottom: var(--0001) 1px solid !important;
}

.color-1129 {
  color: var(--1129) !important;
}

.bg-1129 {
  background-color: var(--1129) !important;
}

.b-1129 {
  border: var(--1129) 1px solid !important;
}

.bs-1129 {
  border-left: var(--1129) 1px solid !important;
}

.be-1129 {
  border-right: var(--1129) 1px solid !important;
}

.bt-1129 {
  border-top: var(--1129) 1px solid !important;
}

.bb-1129 {
  border-bottom: var(--1129) 1px solid !important;
}

.color-4d6c {
  color: var(--4d6c) !important;
}

.bg-4d6c {
  background-color: var(--4d6c) !important;
}

.b-4d6c {
  border: var(--4d6c) 1px solid !important;
}

.bs-4d6c {
  border-left: var(--4d6c) 1px solid !important;
}

.be-4d6c {
  border-right: var(--4d6c) 1px solid !important;
}

.bt-4d6c {
  border-top: var(--4d6c) 1px solid !important;
}

.bb-4d6c {
  border-bottom: var(--4d6c) 1px solid !important;
}

.color-102a {
  color: var(--102a) !important;
}

.bg-102a {
  background-color: var(--102a) !important;
}

.b-102a {
  border: var(--102a) 1px solid !important;
}

.bs-102a {
  border-left: var(--102a) 1px solid !important;
}

.be-102a {
  border-right: var(--102a) 1px solid !important;
}

.bt-102a {
  border-top: var(--102a) 1px solid !important;
}

.bb-102a {
  border-bottom: var(--102a) 1px solid !important;
}

.active-img {
  filter: invert(43%) sepia(99%) saturate(4372%) hue-rotate(235deg) brightness(100%) contrast(102%);
}

.light-img {
  filter: invert(100%) sepia(1%) saturate(1708%) hue-rotate(310deg) brightness(95%) contrast(106%);
}

.dark-mode {
  background: var(--041e);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/color.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAqCA,sBAAA;AAEE;EACE,6BAAA;AAnCJ;;AAqCE;EACE,wCAAA;AAlCJ;;AAoCE;EACE,wCAAA;AAjCJ;;AAmCE;EACE,6CAAA;AAhCJ;;AAkCE;EACE,8CAAA;AA/BJ;;AAiCE;EACE,4CAAA;AA9BJ;;AAgCE;EACE,+CAAA;AA7BJ;;AAUE;EACE,6BAAA;AAPJ;;AASE;EACE,wCAAA;AANJ;;AAQE;EACE,wCAAA;AALJ;;AAOE;EACE,6CAAA;AAJJ;;AAME;EACE,8CAAA;AAHJ;;AAKE;EACE,4CAAA;AAFJ;;AAIE;EACE,+CAAA;AADJ;;AAlBE;EACE,6BAAA;AAqBJ;;AAnBE;EACE,wCAAA;AAsBJ;;AApBE;EACE,wCAAA;AAuBJ;;AArBE;EACE,6CAAA;AAwBJ;;AAtBE;EACE,8CAAA;AAyBJ;;AAvBE;EACE,4CAAA;AA0BJ;;AAxBE;EACE,+CAAA;AA2BJ;;AA9CE;EACE,6BAAA;AAiDJ;;AA/CE;EACE,wCAAA;AAkDJ;;AAhDE;EACE,wCAAA;AAmDJ;;AAjDE;EACE,6CAAA;AAoDJ;;AAlDE;EACE,8CAAA;AAqDJ;;AAnDE;EACE,4CAAA;AAsDJ;;AApDE;EACE,+CAAA;AAuDJ;;AA1EE;EACE,6BAAA;AA6EJ;;AA3EE;EACE,wCAAA;AA8EJ;;AA5EE;EACE,wCAAA;AA+EJ;;AA7EE;EACE,6CAAA;AAgFJ;;AA9EE;EACE,8CAAA;AAiFJ;;AA/EE;EACE,4CAAA;AAkFJ;;AAhFE;EACE,+CAAA;AAmFJ;;AAtGE;EACE,6BAAA;AAyGJ;;AAvGE;EACE,wCAAA;AA0GJ;;AAxGE;EACE,wCAAA;AA2GJ;;AAzGE;EACE,6CAAA;AA4GJ;;AA1GE;EACE,8CAAA;AA6GJ;;AA3GE;EACE,4CAAA;AA8GJ;;AA5GE;EACE,+CAAA;AA+GJ;;AAlIE;EACE,6BAAA;AAqIJ;;AAnIE;EACE,wCAAA;AAsIJ;;AApIE;EACE,wCAAA;AAuIJ;;AArIE;EACE,6CAAA;AAwIJ;;AAtIE;EACE,8CAAA;AAyIJ;;AAvIE;EACE,4CAAA;AA0IJ;;AAxIE;EACE,+CAAA;AA2IJ;;AA9JE;EACE,6BAAA;AAiKJ;;AA/JE;EACE,wCAAA;AAkKJ;;AAhKE;EACE,wCAAA;AAmKJ;;AAjKE;EACE,6CAAA;AAoKJ;;AAlKE;EACE,8CAAA;AAqKJ;;AAnKE;EACE,4CAAA;AAsKJ;;AApKE;EACE,+CAAA;AAuKJ;;AA1LE;EACE,6BAAA;AA6LJ;;AA3LE;EACE,wCAAA;AA8LJ;;AA5LE;EACE,wCAAA;AA+LJ;;AA7LE;EACE,6CAAA;AAgMJ;;AA9LE;EACE,8CAAA;AAiMJ;;AA/LE;EACE,4CAAA;AAkMJ;;AAhME;EACE,+CAAA;AAmMJ;;AAtNE;EACE,6BAAA;AAyNJ;;AAvNE;EACE,wCAAA;AA0NJ;;AAxNE;EACE,wCAAA;AA2NJ;;AAzNE;EACE,6CAAA;AA4NJ;;AA1NE;EACE,8CAAA;AA6NJ;;AA3NE;EACE,4CAAA;AA8NJ;;AA5NE;EACE,+CAAA;AA+NJ;;AAlPE;EACE,6BAAA;AAqPJ;;AAnPE;EACE,wCAAA;AAsPJ;;AApPE;EACE,wCAAA;AAuPJ;;AArPE;EACE,6CAAA;AAwPJ;;AAtPE;EACE,8CAAA;AAyPJ;;AAvPE;EACE,4CAAA;AA0PJ;;AAxPE;EACE,+CAAA;AA2PJ;;AA9QE;EACE,6BAAA;AAiRJ;;AA/QE;EACE,wCAAA;AAkRJ;;AAhRE;EACE,wCAAA;AAmRJ;;AAjRE;EACE,6CAAA;AAoRJ;;AAlRE;EACE,8CAAA;AAqRJ;;AAnRE;EACE,4CAAA;AAsRJ;;AApRE;EACE,+CAAA;AAuRJ;;AA1SE;EACE,6BAAA;AA6SJ;;AA3SE;EACE,wCAAA;AA8SJ;;AA5SE;EACE,wCAAA;AA+SJ;;AA7SE;EACE,6CAAA;AAgTJ;;AA9SE;EACE,8CAAA;AAiTJ;;AA/SE;EACE,4CAAA;AAkTJ;;AAhTE;EACE,+CAAA;AAmTJ;;AAtUE;EACE,6BAAA;AAyUJ;;AAvUE;EACE,wCAAA;AA0UJ;;AAxUE;EACE,wCAAA;AA2UJ;;AAzUE;EACE,6CAAA;AA4UJ;;AA1UE;EACE,8CAAA;AA6UJ;;AA3UE;EACE,4CAAA;AA8UJ;;AA5UE;EACE,+CAAA;AA+UJ;;AAlWE;EACE,6BAAA;AAqWJ;;AAnWE;EACE,wCAAA;AAsWJ;;AApWE;EACE,wCAAA;AAuWJ;;AArWE;EACE,6CAAA;AAwWJ;;AAtWE;EACE,8CAAA;AAyWJ;;AAvWE;EACE,4CAAA;AA0WJ;;AAxWE;EACE,+CAAA;AA2WJ;;AA9XE;EACE,6BAAA;AAiYJ;;AA/XE;EACE,wCAAA;AAkYJ;;AAhYE;EACE,wCAAA;AAmYJ;;AAjYE;EACE,6CAAA;AAoYJ;;AAlYE;EACE,8CAAA;AAqYJ;;AAnYE;EACE,4CAAA;AAsYJ;;AApYE;EACE,+CAAA;AAuYJ;;AA1ZE;EACE,6BAAA;AA6ZJ;;AA3ZE;EACE,wCAAA;AA8ZJ;;AA5ZE;EACE,wCAAA;AA+ZJ;;AA7ZE;EACE,6CAAA;AAgaJ;;AA9ZE;EACE,8CAAA;AAiaJ;;AA/ZE;EACE,4CAAA;AAkaJ;;AAhaE;EACE,+CAAA;AAmaJ;;AAtbE;EACE,6BAAA;AAybJ;;AAvbE;EACE,wCAAA;AA0bJ;;AAxbE;EACE,wCAAA;AA2bJ;;AAzbE;EACE,6CAAA;AA4bJ;;AA1bE;EACE,8CAAA;AA6bJ;;AA3bE;EACE,4CAAA;AA8bJ;;AA5bE;EACE,+CAAA;AA+bJ;;AAldE;EACE,6BAAA;AAqdJ;;AAndE;EACE,wCAAA;AAsdJ;;AApdE;EACE,wCAAA;AAudJ;;AArdE;EACE,6CAAA;AAwdJ;;AAtdE;EACE,8CAAA;AAydJ;;AAvdE;EACE,4CAAA;AA0dJ;;AAxdE;EACE,+CAAA;AA2dJ;;AA9eE;EACE,6BAAA;AAifJ;;AA/eE;EACE,wCAAA;AAkfJ;;AAhfE;EACE,wCAAA;AAmfJ;;AAjfE;EACE,6CAAA;AAofJ;;AAlfE;EACE,8CAAA;AAqfJ;;AAnfE;EACE,4CAAA;AAsfJ;;AApfE;EACE,+CAAA;AAufJ;;AA1gBE;EACE,6BAAA;AA6gBJ;;AA3gBE;EACE,wCAAA;AA8gBJ;;AA5gBE;EACE,wCAAA;AA+gBJ;;AA7gBE;EACE,6CAAA;AAghBJ;;AA9gBE;EACE,8CAAA;AAihBJ;;AA/gBE;EACE,4CAAA;AAkhBJ;;AAhhBE;EACE,+CAAA;AAmhBJ;;AAtiBE;EACE,6BAAA;AAyiBJ;;AAviBE;EACE,wCAAA;AA0iBJ;;AAxiBE;EACE,wCAAA;AA2iBJ;;AAziBE;EACE,6CAAA;AA4iBJ;;AA1iBE;EACE,8CAAA;AA6iBJ;;AA3iBE;EACE,4CAAA;AA8iBJ;;AA5iBE;EACE,+CAAA;AA+iBJ;;AAlkBE;EACE,6BAAA;AAqkBJ;;AAnkBE;EACE,wCAAA;AAskBJ;;AApkBE;EACE,wCAAA;AAukBJ;;AArkBE;EACE,6CAAA;AAwkBJ;;AAtkBE;EACE,8CAAA;AAykBJ;;AAvkBE;EACE,4CAAA;AA0kBJ;;AAxkBE;EACE,+CAAA;AA2kBJ;;AA9lBE;EACE,6BAAA;AAimBJ;;AA/lBE;EACE,wCAAA;AAkmBJ;;AAhmBE;EACE,wCAAA;AAmmBJ;;AAjmBE;EACE,6CAAA;AAomBJ;;AAlmBE;EACE,8CAAA;AAqmBJ;;AAnmBE;EACE,4CAAA;AAsmBJ;;AApmBE;EACE,+CAAA;AAumBJ;;AA1nBE;EACE,6BAAA;AA6nBJ;;AA3nBE;EACE,wCAAA;AA8nBJ;;AA5nBE;EACE,wCAAA;AA+nBJ;;AA7nBE;EACE,6CAAA;AAgoBJ;;AA9nBE;EACE,8CAAA;AAioBJ;;AA/nBE;EACE,4CAAA;AAkoBJ;;AAhoBE;EACE,+CAAA;AAmoBJ;;AAtpBE;EACE,6BAAA;AAypBJ;;AAvpBE;EACE,wCAAA;AA0pBJ;;AAxpBE;EACE,wCAAA;AA2pBJ;;AAzpBE;EACE,6CAAA;AA4pBJ;;AA1pBE;EACE,8CAAA;AA6pBJ;;AA3pBE;EACE,4CAAA;AA8pBJ;;AA5pBE;EACE,+CAAA;AA+pBJ;;AAlrBE;EACE,6BAAA;AAqrBJ;;AAnrBE;EACE,wCAAA;AAsrBJ;;AAprBE;EACE,wCAAA;AAurBJ;;AArrBE;EACE,6CAAA;AAwrBJ;;AAtrBE;EACE,8CAAA;AAyrBJ;;AAvrBE;EACE,4CAAA;AA0rBJ;;AAxrBE;EACE,+CAAA;AA2rBJ;;AA9sBE;EACE,6BAAA;AAitBJ;;AA/sBE;EACE,wCAAA;AAktBJ;;AAhtBE;EACE,wCAAA;AAmtBJ;;AAjtBE;EACE,6CAAA;AAotBJ;;AAltBE;EACE,8CAAA;AAqtBJ;;AAntBE;EACE,4CAAA;AAstBJ;;AAptBE;EACE,+CAAA;AAutBJ;;AA1uBE;EACE,6BAAA;AA6uBJ;;AA3uBE;EACE,wCAAA;AA8uBJ;;AA5uBE;EACE,wCAAA;AA+uBJ;;AA7uBE;EACE,6CAAA;AAgvBJ;;AA9uBE;EACE,8CAAA;AAivBJ;;AA/uBE;EACE,4CAAA;AAkvBJ;;AAhvBE;EACE,+CAAA;AAmvBJ;;AAtwBE;EACE,6BAAA;AAywBJ;;AAvwBE;EACE,wCAAA;AA0wBJ;;AAxwBE;EACE,wCAAA;AA2wBJ;;AAzwBE;EACE,6CAAA;AA4wBJ;;AA1wBE;EACE,8CAAA;AA6wBJ;;AA3wBE;EACE,4CAAA;AA8wBJ;;AA5wBE;EACE,+CAAA;AA+wBJ;;AAlyBE;EACE,6BAAA;AAqyBJ;;AAnyBE;EACE,wCAAA;AAsyBJ;;AApyBE;EACE,wCAAA;AAuyBJ;;AAryBE;EACE,6CAAA;AAwyBJ;;AAtyBE;EACE,8CAAA;AAyyBJ;;AAvyBE;EACE,4CAAA;AA0yBJ;;AAxyBE;EACE,+CAAA;AA2yBJ;;AA9zBE;EACE,6BAAA;AAi0BJ;;AA/zBE;EACE,wCAAA;AAk0BJ;;AAh0BE;EACE,wCAAA;AAm0BJ;;AAj0BE;EACE,6CAAA;AAo0BJ;;AAl0BE;EACE,8CAAA;AAq0BJ;;AAn0BE;EACE,4CAAA;AAs0BJ;;AAp0BE;EACE,+CAAA;AAu0BJ;;AAn0BA;EACE,iGAAA;AAs0BF;;AAn0BA;EACE,gGAAA;AAs0BF;;AAl0BA;EACE,uBAAA;AAq0BF","sourcesContent":[":root {\r\n  --ffff: #ffffff;\r\n  --0000: #000000;\r\n  --0001: #000000bb;\r\n  --0d6e: #0d6efd;\r\n  --0dca: #0dcaf0;\r\n  --8754: #198754;\r\n  --ad2a: #46ad2a;\r\n  --f4e2: #e6f4e2;\r\n  --ffc1: #ffc107;\r\n  --e3e3: #e3e3e3;\r\n  --2749: #0e2749;\r\n  --dee3: #dcdee3;\r\n  --edf0: #eaedf0;\r\n  --56ff: #6c56ff;\r\n  --7e91: #777e91;\r\n  --f9fb: #f8f9fb;\r\n  --4639: #d94639;\r\n  --dc35: #dc3545;\r\n  --e2e2: #f4e2e2;\r\n  --2a2a: #ad2a2a;\r\n  --faff: #fafaff;\r\n  --eeff: #f0eeff;\r\n  --b5c0: #b1b5c0;\r\n  --bbff: #c4bbff;\r\n  --1129: #0f1129;\r\n  --4d6c: #4b4d6c;\r\n  --2b4e: #282b4e;\r\n  --c9c9: #c9c9c9;\r\n  --102a: #0e102a;\r\n  --2ae5: #070a3149;\r\n  --041e: #02041e;\r\n}\r\n\r\n$colors: (\r\n  \"tr\": transparent,\r\n  \"ffff\": var(--ffff),\r\n  \"041e\": var(--041e),\r\n  \"2ae5\": var(--2ae5),\r\n  \"c9c9\": var(--c9c9),\r\n  \"2b4e\": var(--2b4e),\r\n  \"0000\": var(--0000),\r\n  \"0d6e\": var(--0d6e),\r\n  \"0dca\": var(--0dca),\r\n  \"8754\": var(--8754),\r\n  \"dc35\": var(--dc35),\r\n  \"ffc1\": var(--ffc1),\r\n  \"e3e3\": var(--e3e3),\r\n  \"2749\": var(--2749),\r\n  \"dee3\": var(--dee3),\r\n  \"edf0\": var(--edf0),\r\n  \"56ff\": var(--56ff),\r\n  \"7e91\": var(--7e91),\r\n  \"f9fb\": var(--f9fb),\r\n  \"4639\": var(--4639),\r\n  \"faff\": var(--faff),\r\n  \"eeff\": var(--eeff),\r\n  \"b5c0\": var(--b5c0),\r\n  \"bbff\": var(--bbff),\r\n  \"ad2a\": var(--ad2a),\r\n  \"f4e2\": var(--f4e2),\r\n  \"e2e2\": var(--e2e2),\r\n  \"2a2a\": var(--2a2a),\r\n  \"0001\": var(--0001),\r\n  \"1129\": var(--1129),\r\n  \"4d6c\": var(--4d6c),\r\n  \"102a\": var(--102a),\r\n);\r\n\r\n/* Light mode styles */\r\n@each $name, $color in $colors {\r\n  .color-#{$name} {\r\n    color: $color !important;\r\n  }\r\n  .bg-#{$name} {\r\n    background-color: $color !important;\r\n  }\r\n  .b-#{$name} {\r\n    border: $color 1px solid !important;\r\n  }\r\n  .bs-#{$name} {\r\n    border-left: $color 1px solid !important;\r\n  }\r\n  .be-#{$name} {\r\n    border-right: $color 1px solid !important;\r\n  }\r\n  .bt-#{$name} {\r\n    border-top: $color 1px solid !important;\r\n  }\r\n  .bb-#{$name} {\r\n    border-bottom: $color 1px solid !important;\r\n  }\r\n}\r\n\r\n.active-img {\r\n  filter: invert(43%) sepia(99%) saturate(4372%) hue-rotate(235deg)\r\n    brightness(100%) contrast(102%);\r\n}\r\n.light-img {\r\n  filter: invert(100%) sepia(1%) saturate(1708%) hue-rotate(310deg)\r\n    brightness(95%) contrast(106%);\r\n}\r\n\r\n.dark-mode {\r\n  background: var(--041e);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
